import { DefaultOptions, QueryClient } from "@tanstack/react-query";

export const createQueryClient = (overrides?: DefaultOptions) =>
  new QueryClient({
    defaultOptions: {
      ...(overrides ?? {}),
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retryOnMount: false,
        retry: 0,
        refetchInterval: 0,
        ...overrides?.queries,
      },
    },
  });

export { QueryClientProvider, useQueryClient } from "@tanstack/react-query";
export type {
  UseQueryResult,
  QueryClient,
  UseMutateAsyncFunction,
} from "@tanstack/react-query";
export { ReactQueryDevtools } from "@tanstack/react-query-devtools";
